module.exports = __webpack_public_path__ + "img/TaskFino logo white.b06fd546.png";